import {Fragment} from 'react'
import Banner from "../components/Banner";
import Carousel from '../components/Carousel';



export default function Home() {
    return(
        <Fragment>
         <Banner/>
         <Carousel/>
    
        </Fragment>
    )
}

